import React, { useRef, useState } from "react";
import {
  Layout as AntLayout,
  Menu,
  Button,
  Popover,
  Badge,
  Avatar,
  Col,
  Row,
  Modal,
  Form,
  Input,
} from "antd";
import { CaretDownOutlined, MenuOutlined } from "@ant-design/icons";

import "./styles.scss";
import { useLocation, Link, useHistory } from "react-router-dom";
import { logo1 } from "../assets/images";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/actions/Auth/auth.actions";
import {
  superAdmin,
  admin,
  subAdmin,
  actingadmin,
  editoradmin,
  vieweradmin,
  superAdminEditor,
  developer,
  whiteLabelAdmin,
} from "../container/Main/Menu";
import { COLORS } from "../config/theme";
import useOnClickOutside from "../hooks/useOnClickOutside";
import { request } from "../config/API";
import authHeader from "../redux/services/authHeader";
import { openNotification } from "../redux/actions/Notification/notifications.action";
import {
  ACTING_ADMIN,
  ADMIN,
  DEVELOPER,
  EDITOR_ADMIN,
  SUB_ADMIN,
  SUPER_ADMIN,
  SUPER_ADMIN_EDITOR,
  VIWEER_ADMIN,
  WHITE_LABEL_ADMIN,
} from "../config/roles";
import { UPDATE_NAME } from "../redux/actions/Auth/authTypes";
import { openSliderAction } from "../redux/actions/Admin/admin.actions";

const Layout = ({ children, heading, hasBadge, stat }) => {
  const { white, primaryDark } = COLORS;

  const [isCollapsed, setIsCollapsed] = useState(
    JSON.parse(localStorage.getItem("isCollapsed")) || false
  );
  const { Header, Sider, Content, Footer } = AntLayout;
  const dispatch = useDispatch();

  const [popupVisible, setpopupVisible] = useState(false);
  const handleVisibleChange = (visible) => setpopupVisible(visible);

  const [changeNameModal, setChangeNameModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [isPassChanging, setIsPassChanging] = useState(false);
  const [isNameChanging, setIsNameChanging] = useState(false);

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  const location = useLocation();
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const { openSlider } = useSelector((state) => state.user);

  const { subscribedPlan } = useSelector((state) => state.membership);
  const handlePasswordChange = (values) => {
    const data = { ...values, id: user?._id };
    setIsPassChanging(true);
    request
      .post(`user/user-change-password`, data, {
        headers: { ...authHeader() },
      })
      .then(() => {
        setIsPassChanging(false);
        setChangePasswordModal(false);
        form1.resetFields();
        openNotification({
          message: "Success!",
          description: "Password Updated Successfully",
          icon: "success",
        });
      })
      .catch((err) => {
        setIsPassChanging(false);
        const error =
          err?.response?.data.data ||
          err?.response?.data.message ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };
  const handleChangeFullName = (values) => {
    const data = { ...values, id: user?._id };
    const newName = values.fullName;
    setIsNameChanging(true);
    request
      .post(`user/user-change-full-name`, data)
      .then(() => {
        setIsNameChanging(false);
        setChangeNameModal(false);
        dispatch({
          type: UPDATE_NAME,
          payload: newName,
        });
        form1.resetFields();
        openNotification({
          message: "Success!",
          description: "Full Name Updated Successfully",
          icon: "success",
        });
      })
      .catch((err) => {
        setIsNameChanging(false);
        const error =
          err?.response?.data.data ||
          err?.response?.data.message ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };
  const logOut = () => {
    dispatch(logout(user));
    if (user.role === WHITE_LABEL_ADMIN) {
      history.push("/login-page2");
    } else {
      history.push("/login");
    }
  };
  let arr = location.pathname.split("/");
  let key = `/${arr[1]}/${arr[2]}`;
  if (arr.length < 3) {
    key = `/${arr[1]}`;
  }
  //eslint-disable-next-line
  const [selected, setSelected] = useState(window.location.pathname);
  let menuList = [];
  switch (user?.role) {
    case SUPER_ADMIN:
      menuList = superAdmin;
      break;
    case SUPER_ADMIN_EDITOR:
      menuList = superAdminEditor;
      break;
    case DEVELOPER:
      menuList = developer;
      break;
    case ADMIN:
      menuList = admin;
      break;
    case ACTING_ADMIN:
      menuList = actingadmin;
      break;
    case EDITOR_ADMIN:
      menuList = editoradmin;
      break;
    case VIWEER_ADMIN:
      menuList = vieweradmin;
      break;
    case WHITE_LABEL_ADMIN:
      menuList = whiteLabelAdmin;
      break;
    default:
      menuList = subAdmin;
  }
  const ref = useRef();

  useOnClickOutside(ref, () => {
    dispatch(openSliderAction(false));
  });
  return (
    <AntLayout style={{ minHeight: "100vh" }}>
      <Sider
        ref={ref}
        className={`ant-sider ${openSlider && "ant-layout-sider-open"}`}
        collapsible
        collapsed={isCollapsed}
        onCollapse={() => {
          setIsCollapsed(!isCollapsed);
          localStorage.setItem("isCollapsed", !isCollapsed);
        }}
      >
        {user?.role !== WHITE_LABEL_ADMIN && (
          <div
            className="ant-sider-header"
            style={{ textAlign: "center", marginTop: 24 }}
          >
            <Link
              to={
                user?.role === SUB_ADMIN || user?.role === DEVELOPER
                  ? "/app/wave-cards"
                  : "/"
              }
            >
              <img
                alt="logo"
                draggable={false}
                src={logo1}
                style={{ width: isCollapsed ? 60 : 150, borderRadius: 0 }}
              />
            </Link>
          </div>
        )}
        <Menu
          style={{
            marginTop: 50,
            background: white,
          }}
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[key]}
          selectedKeys={[key]}
          onSelect={({ key }) => {
            history.push(key);
            setSelected(key);
          }}
        >
          {menuList.map((m, index) => (
            <>
              {m.link === "/app/lead-generation" ? (
                user?.role === SUPER_ADMIN ? (
                  <Menu.Item
                    key={m.link}
                    style={{
                      borderRadius: 50,
                      margin: "20px 0",
                      color: key === m.link ? white : primaryDark,
                      background: key !== m.link ? white : primaryDark,
                    }}
                  >
                    {m.icon}
                    <span>{m.title}</span>
                  </Menu.Item>
                ) : (
                  subscribedPlan?.paymentStatus &&
                  subscribedPlan?.paymentStatus === "SUCCESS" && (
                    <Menu.Item
                      key={m.link}
                      style={{
                        borderRadius: 50,
                        margin: "20px 0",
                        color: key === m.link ? white : primaryDark,
                        background: key !== m.link ? white : primaryDark,
                      }}
                    >
                      {m.icon}
                      <span>{m.title}</span>
                    </Menu.Item>
                  )
                )
              ) : (
                <Menu.Item
                  id={m.title.replaceAll(" ", "").toLocaleLowerCase()}
                  key={m.link}
                  style={{
                    borderRadius: 50,
                    margin: "20px 0",
                    color: key === m.link ? white : primaryDark,
                    background: key !== m.link ? white : primaryDark,
                  }}
                >
                  {m.icon}
                  <span>{m.title}</span>
                </Menu.Item>
              )}
            </>
          ))}
        </Menu>
      </Sider>
      <AntLayout className="site-layout">
        <Header style={{ backgroundColor: primaryDark, height: 350 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 15,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <MenuOutlined
                className="hamburger"
                style={{ color: "white", marginRight: ".5rem" }}
                onClick={() => dispatch(openSliderAction(true))}
              />
              <h1
                className="heading"
                style={{
                  color: white,
                  margin: 0,
                  textTransform: "capitalize",
                  fontWeight: "500",
                }}
              >
                {heading}
                {hasBadge && (
                  <Badge
                    count={stat}
                    style={{ backgroundColor: white, color: primaryDark }}
                    overflowCount={999999}
                    offset={[10, -25]}
                  />
                )}
              </h1>
            </div>
            <div>
              <Popover
                id="logoutMenu"
                placement="bottomRight"
                content={
                  <Col>
                    <Row>
                      <Button
                        size="small"
                        type="link"
                        style={{ color: primaryDark }}
                        onClick={() => {
                          setChangeNameModal(true);
                        }}
                      >
                        Change Name
                      </Button>
                    </Row>
                    <Row>
                      <Button
                        size="small"
                        type="link"
                        style={{ color: primaryDark }}
                        onClick={() => {
                          setChangePasswordModal(true);
                        }}
                      >
                        Change Password
                      </Button>
                    </Row>
                    <Row>
                      <Button
                        size="small"
                        type="link"
                        style={{ color: primaryDark }}
                        onClick={logOut}
                      >
                        Log out
                      </Button>
                    </Row>
                  </Col>
                }
                trigger="click"
                visible={popupVisible}
                onVisibleChange={handleVisibleChange}
              >
                <Button
                  id="avatar-2"
                  size="middle"
                  type="link"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 10px",
                    borderRadius: "50px",
                    backgroundColor: white,
                    color: primaryDark,
                  }}
                >
                  <Avatar
                    style={{ marginRight: 5, backgroundColor: primaryDark }}
                    size="small"
                  >
                    {user && user?.fullName?.substring(0, 1)}
                  </Avatar>
                  {user && user?.fullName}
                  <CaretDownOutlined />
                </Button>
              </Popover>
            </div>
          </div>
        </Header>
        {/* <AnimatePresence exitBeforeEnter> */}
        <Content
          className="site-layout-background-content"
          style={{
            margin: "24px 16px",
            backgroundColor: white,
            boxShadow: "8px 13px 34px -8px rgba(0,0,0,0.14)",
            borderRadius: 13,
            minHeight: 280,
          }}
        >
          {children}
        </Content>
        {user?.role !== WHITE_LABEL_ADMIN && (
          <Footer style={{ textAlign: "center" }}>
            Copyright © {new Date().getFullYear()}{" "}
            <a
              href={`${
                process.env.REACT_APP_DOMAIN_URL || "https://wavecodes.com.au"
              }`}
              target="_blank"
              rel="noreferrer"
            >
              {process.env.REACT_APP_DOMAIN || "wavecodes.com.au"}
            </a>{" "}
            All Rights Reserved.
          </Footer>
        )}
      </AntLayout>
      <Modal
        title="Change Name"
        visible={changeNameModal}
        footer={null}
        onCancel={() => setChangeNameModal(false)}
        centered
      >
        <Form form={form1} onFinish={handleChangeFullName}>
          <Form.Item
            initialValue={user.fullName}
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Full Name"
            name="fullName"
            hasFeedback
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input size="large" style={{ borderRadius: 8 }} />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isNameChanging}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Change Password"
        visible={changePasswordModal}
        footer={null}
        onCancel={() => setChangePasswordModal(false)}
        centered
      >
        <Form form={form2} onFinish={handlePasswordChange}>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Password"
            name="password"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { min: 6, message: "Password should be atleast 6 characters" },
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="New Password"
            name="newPassword"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { min: 6, message: "Password should be atleast 6 characters" },
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Re-Password"
            name="confirmPassword"
            hasFeedback
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "This field is required" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isPassChanging}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </AntLayout>
  );
};

export default Layout;
